module.exports = __webpack_public_path__ + "img/warn_04.7bfa8515.png";